<app-breadcrumb [title]="'user'|translate" [items]="['security'|translate]" [active_item]="'user'|translate"></app-breadcrumb>
<style>
  .custom-card-erp{
    margin-bottom: 30px;
    display: flex;
    flex-direction: column;
  }

  @media screen and (max-width: 800px) {
    .desktop-hidden {
      display: initial;
    }
    .mobile-hidden {
      display: none;
    }
  }
  @media screen and (min-width: 800px) {
    .desktop-hidden {
      display: none;
    }
    .mobile-hidden {
      display: initial;
    }
  }

</style>

<div class="container-fluid">
  <div class="row">
    <div class="col-sm-12">


      <div class="custom-card-erp">
        <div style="float:left;">
          <input
                  type="text"
                  style="padding:5px;margin:5px auto;width:30%;"
                  placeholder="{{ 'type to filter the name column...'|translate }}"
                  (keyup)="updateFilter($event)"
          />

          <div style="float: right; margin: 5px;">
            <div class="btn-group-vertical me-2" role="group" aria-label="Vertical button group" *ngIf="this.isButtonVisible">
              <div ngbDropdown placement="top" class="btn-group" role="group">
                <button type="button" class="btn btn-outline-primary dropdown-toggle" id="dropdownBasic1"
                        ngbDropdownToggle>{{ 'global actions'|translate }}</button>
                <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                  <button class="dropdown-item" (click)="deleteSelectedUserRows()">{{ 'delete selection'|translate }}</button>
                </div>
              </div>
            </div>

            <button class="btn btn-outline-primary" (click)="addUser()">{{ 'add'|translate }}</button>
          </div>

        </div>


        <ngx-datatable
                style="width: 100%"
                class="material striped"
                selectionType="checkbox"
                [rows]="rows"
                [headerHeight]="50"
                [footerHeight]="50"
                [limit]="50"
                rowHeight="auto"
                columnMode="force"
                [scrollbarH]="true"
                [loadingIndicator]="loadingIndicator"
                [reorderable]="reorderable"
                [selected]="selected"
                (select)="onSelect($event)"
                [selectAllRowsOnPage]="false"
        >
          <ngx-datatable-column
                  [width]="55"
                  [sortable]="false"
                  [canAutoResize]="false"
                  [draggable]="false"
                  [resizeable]="false"
                  [headerCheckboxable]="true"
                  [checkboxable]="true"
          >
            </ngx-datatable-column>

          <!--<ngx-datatable-column name="picture">
            <ng-template let-column="column" ngx-datatable-header-template>
              <span class="f-w-700 sp-policy-erp">{{ 'picture'|translate }}</span>
            </ng-template>

            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
              <ng-container *ngIf="row.fileType === 'image/png' || row.fileType === 'image/jpg' || row.fileType === 'image/jpeg'; else otherFormat">
                <img [src]="row.picture" alt="Image" width="50" height="50">
              </ng-container>
              <ng-template #otherFormat>
                <a href="{{ row.picture }}" target="_blank">{{ row.fileName }}</a>
              </ng-template>
            </ng-template>
          </ngx-datatable-column>-->


          <ngx-datatable-column name="picture">
            <ng-template let-column="column" ngx-datatable-header-template>
              <span class="f-w-700 sp-policy-erp">{{ 'picture' | translate }}</span>
            </ng-template>
            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
              <ng-container *ngIf="(row.imageType === 'image/png' || row.imageType === 'image/jpg' || row.imageType === 'image/jpeg') && row.picture; else otherFormat">
                <a href="{{ row.picture }}" target="_blank">
                  <img [src]="row.picture" alt="Image" width="50" height="50">
                </a>
              </ng-container>

              <ng-template #otherFormat>
                <ng-container *ngIf="row.picture; else defaultImage">
                  <a href="{{ row.picture }}" target="_blank">{{ row.imageName }}</a>
                </ng-container>
              </ng-template>

              <ng-template #defaultImage>
                <a href="{{ defaultImg }}" target="_blank">
                  <img [src]="defaultImg" alt="Default Image" width="50" height="50">
                </a>
              </ng-template>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column>
            <ng-template let-column="column" ngx-datatable-header-template>
              <span class="f-w-700 sp-policy-erp">{{ 'name'|translate }}</span>
            </ng-template>
            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
              {{row.firstname }}  {{row.lastname }}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="phone">
            <ng-template let-column="column" ngx-datatable-header-template>
              <span class="f-w-700 sp-policy-erp">{{ 'phone'|translate }}</span>
            </ng-template>
            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
              <span class="font-primary">{{row.phone}}</span>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="username">
            <ng-template let-column="column" ngx-datatable-header-template>
              <span class="f-w-700 sp-policy-erp">{{ 'username'|translate }}</span>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="profile">
            <ng-template let-column="column" ngx-datatable-header-template>
              <span class="f-w-700 sp-policy-erp">{{ 'profile'|translate }}</span>
            </ng-template>
            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
              <span class="badge rounded-pill badge-light-success" style="font-size: 12px;">{{row.profile ? row.profile.name : "" }}</span>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="email">
            <ng-template let-column="column" ngx-datatable-header-template>
              <span class="f-w-700 sp-policy-erp">{{ 'email'|translate }}</span>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="branch">
            <ng-template let-column="column" ngx-datatable-header-template>
              <span class="f-w-700 sp-policy-erp">{{ 'branch'|translate }}</span>
            </ng-template>
            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
              {{row.branch ? row.branch.code : "" }}
            </ng-template>
          </ngx-datatable-column>

          <!--<ngx-datatable-column name="institution">
            <ng-template let-column="column" ngx-datatable-header-template>
              <span class="f-w-700 sp-policy-erp">{{ 'institution'|translate }}</span>
            </ng-template>
            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
              <span class="badge rounded-pill badge-light-success" style="font-size: 12px;">{{row.institution ? row.institution.code : "" }}</span>
            </ng-template>
          </ngx-datatable-column>-->

            <ngx-datatable-column name="isEnable">
                <ng-template let-column="column" ngx-datatable-header-template>
                    <span class="f-w-700 sp-policy-erp">{{ 'status'|translate }}</span>
                </ng-template>

                <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                    <ng-container *ngIf="row.isEnable == 1; else otherFormat">
                        <span class="badge rounded-pill badge-light-success" style="font-size: 13px">{{ 'enabled' | translate }}</span>
                    </ng-container>
                    <ng-template #otherFormat>
                        <span class="badge rounded-pill badge-light-danger" style="font-size: 13px">{{ 'disabled' | translate }}</span>
                    </ng-template>
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column [frozenRight]="true" name="actions">
              <ng-template let-column="column" ngx-datatable-header-template>
                <span class="f-w-700 sp-policy-erp">{{ 'actions'|translate }}</span>
              </ng-template>
              <ng-template  let-row="row" let-value="value" ngx-datatable-cell-template>
                <a (click)="editUser(row.id)" type="button" placement="top" ngbTooltip="{{ 'update'|translate }}"><i class="icon-pencil-alt text-success" style="cursor: pointer"></i></a>
                <a (click)="deleteUser(row.id)" type="button" placement="top" ngbTooltip="{{ 'delete'|translate }}"><i class="icon-trash text-danger ms-2" style="cursor: pointer"></i></a>
                <a (click)="updatePassword(row)" type="button" placement="top" ngbTooltip="{{ 'update password'|translate }}"><i class="icon-unlock text-warning ms-2" style="cursor: pointer"></i></a>
                <a (click)="updateUserBranch(row)" type="button" placement="top" ngbTooltip="{{ 'branches'|translate }}"><i class="fa-bank text-primary ms-2" style="cursor: pointer"></i></a>
              </ng-template>
            </ngx-datatable-column>
          </ngx-datatable>

      </div>

    </div>
    </div>
  </div>






